import React, { useState, useEffect, useRef } from 'react';
import { TextField, Box, Typography, Paper, IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/CloseOutlined';
import '../App.css';
import { useTranslation } from 'react-i18next';
import { inserirSubConta, criaRemetente } from '../services/service';

const FormularioTpp = ({ onClose, onReady, onError, onSuccess }) => {
  const { t } = useTranslation();
  const idMetaApp = process.env.REACT_APP_ID_META_APP;
  const idConfigApp = process.env.REACT_APP_ID_CONFIG_APP;
  const solutionId = process.env.REACT_APP_SOLUTION_ID;

  useEffect(() => {
    window.fbAsyncInit = function () {
      window.FB.init({
        appId: idMetaApp,
        version: 'v18.0',
      });
    };
    const script = document.createElement('script');
    script.src = 'https://connect.facebook.net/en_US/sdk.js';
    script.async = true;
    script.defer = true;
    script.crossOrigin = 'anonymous';
    document.body.appendChild(script);
    return () => {
      document.body.removeChild(script);
    };
  }, [idMetaApp]);

  const launchEmbeddedSignup = () => {
    window.FB.login(
      function (response) {
        console.log('Login response:', response);
      },
      {
        config_id: idConfigApp,
        auth_type: "rerequest",
        response_type: "code",
        override_default_response_type: true,
        extras: {
          sessionInfoVersion: 2,
          setup: {
            solutionID: solutionId,
          },
        },
      }
    );
  };

  const [formData, setFormData] = useState({ farmacia: '', telefone: '' });
  const [errors, setErrors] = useState({ farmacia: false, telefone: false });
  const formDataRef = useRef(formData);

  useEffect(() => {
    formDataRef.current = formData;
  }, [formData]);

  const handleClose = () => {
    onClose();
  };

  const handleChange = async (event) => {
    const { name, value } = event.target;
    if (name === 'telefone' && !/^\d*$/.test(value)) {
      return;
    }

    const updatedFormData = { ...formData, [name]: value };
    setFormData(updatedFormData);

    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: value === '',
    }));
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    const newErrors = { farmacia: formData.farmacia === '', telefone: formData.telefone === '' };
    setErrors(newErrors);
    if (Object.values(newErrors).includes(true)) {
      return;
    }

    if (formData.farmacia.trim() !== '' && formData.telefone.trim() !== '') {
      launchEmbeddedSignup();
    }    
  };

  const embeddedSignupInfoListener = async (event) => {
    if (!event.origin.endsWith("facebook.com")) return;
    try {
      const data = JSON.parse(event.data);
      if (data.type === "WA_EMBEDDED_SIGNUP") {
        if (data.event === "FINISH" || data.event === "FINISH_ONLY_WABA") {
          const { phone_number_id, waba_id } = data.data;
          if (phone_number_id && waba_id) {
            onReady(true);
            const subContaResponse = await inserirSubConta(formDataRef.current.farmacia);
            if (subContaResponse.TypeError) {
              onReady(false);
              onError("Serviço indisponível");
              return;
            }
            if (subContaResponse.Error) {
              onReady(false);
              onError(subContaResponse.Error);
              return;
            }
            const remetentePayload = {
              senderId: formDataRef.current.telefone,
              wabaId: waba_id,
              authToken: subContaResponse.auth_token,
              sid: subContaResponse.sid
            };
            const remetente = await criaRemetente(remetentePayload);
            if (remetente.Error) {
              onReady(false);
              onError(remetente.Error);
              return;
            }
            if (remetente.TypeError) {
              onReady(false);
              onError(remetente.Error);
              return;
            }
            onReady(false);
            onSuccess();
          }
        }
      }
    } catch (error) {
      console.error("Error parsing event data:", error);
    }
  };

  useEffect(() => {
    window.addEventListener("message", embeddedSignupInfoListener);
    return () => {
      window.removeEventListener("message", embeddedSignupInfoListener);
    };
  }, []);

  return (
    <Paper
      elevation={3}
      sx={{
        padding: '20px',
        borderRadius: '8px',
        border: '2px solid #D3D3D3',
        maxWidth: 700,
        margin: 'auto',
        marginTop: '100px',
      }}
    >
      <form onSubmit={handleSubmit}>
        <Box display="flex" flexDirection="column" gap={3}>
          <Box display="flex" justifyContent="space-between" alignItems="center">
            <Typography variant="subtitle1" component="p" sx={{ fontWeight: 'bold', fontSize: '18px' }}>
              {t('main.preencha-formulario')}
            </Typography>
            <IconButton onClick={handleClose} style={{ color: '#808080' }}>
              <CloseIcon />
            </IconButton>
          </Box>
          <Box>
            <Typography variant="subtitle2" component="p" textAlign={'left'} marginBottom={1}>
              {t("main.nome-farmacia")}
            </Typography>
            <TextField
              name="farmacia"
              value={formData.farmacia}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              required
              error={errors.farmacia}
              helperText={errors.farmacia ? t("main.obrigatorio") : ""}
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                },
                '& .MuiFormHelperText-root': {
                  marginLeft: 0,
                },
              }}
              inputProps={{
                maxLength: 30,
              }}
            />
          </Box>
          <Box>
            <Typography variant="subtitle2" component="p" textAlign={'left'} marginBottom={1}>
              {t("main.telefone")}
            </Typography>
            <TextField
              name="telefone"
              value={formData.telefone}
              onChange={handleChange}
              fullWidth
              variant="outlined"
              required
              error={errors.telefone}
              helperText={errors.telefone ? t("main.obrigatorio-telefone") : ""}
              sx={{
                '& .MuiOutlinedInput-root': {
                  height: '40px',
                },
                '& .MuiFormHelperText-root': {
                  marginLeft: 0,
                },
              }}
              inputProps={{
                maxLength: 15,
              }}
            />
          </Box>
          <Box display={'flex'} justifyContent={'end'}>
            <button
              type="submit"
              className={`botaoAvancar ${
                !formData.farmacia.trim() || !formData.telefone.trim() ? 'corBotaoDisabled' : ''
              }`}
              disabled={!formData.farmacia.trim() || !formData.telefone.trim()}
            >
              {t("main.botao-avanca")}
            </button>
          </Box>
        </Box>
      </form>
    </Paper>
  );
};

export default FormularioTpp;
